import { createPreviewFieldStmtInstruction } from './AddPreviewFieldStmt';
import { createPreviewStmtInstruction } from './CreatePreviewStmt';
import { removePreviewFieldStmtInstruction } from './RemovePreviewFieldStmt';
import { removePreviewStmtInstruction } from './RemovePreviewStmt';
export const previewInstruction = `
## Preview
It's a group of fields that define how the Entity is represented in the UI, usually in select field or other places where the user needs to see text representation of the Entity. Most of the time, it's a combination of multiple fields like name, title, time of creation, etc.

### Preview commands

${createPreviewStmtInstruction}
${removePreviewStmtInstruction}
${createPreviewFieldStmtInstruction}
${removePreviewFieldStmtInstruction}
`;
//# sourceMappingURL=previewInstruction.js.map